export class Match {

   PairingId: string;
   Forfeit: boolean = false;
   Retired: boolean = false;
   Set1Player1Score: number;
   Set1Player2Score: number;
   Set2Player1Score: number;
   Set2Player2Score: number;
   Set3Player1Score: number;
   Set3Player2Score: number;

   Set1Player1Tie: number;
   Set1Player2Tie: number;
   Set2Player1Tie: number;
   Set2Player2Tie: number;
   Set3Player1Tie: number;
   Set3Player2Tie: number;
   public constructor(init?: Partial<Match>) {
      Object.assign(this, init);
      if (typeof init.Set1Player1Score === 'string') this.Set1Player1Score = parseInt(init.Set1Player1Score, 10);
      if (typeof init.Set1Player2Score === 'string') this.Set1Player2Score = parseInt(init.Set1Player2Score, 10);
      if (typeof init.Set2Player1Score === 'string') this.Set2Player1Score = parseInt(init.Set2Player1Score, 10);
      if (typeof init.Set2Player2Score === 'string') this.Set2Player2Score = parseInt(init.Set2Player2Score, 10);
      if (typeof init.Set3Player1Score === 'string') this.Set3Player1Score = parseInt(init.Set3Player1Score, 10);
      if (typeof init.Set3Player2Score === 'string') this.Set3Player2Score = parseInt(init.Set3Player2Score, 10);

      if (typeof init.Set1Player1Tie === 'string') this.Set1Player1Tie = parseInt(init.Set1Player1Tie, 10);
      if (typeof init.Set1Player2Tie === 'string') this.Set1Player2Tie = parseInt(init.Set1Player2Tie, 10);
      if (typeof init.Set2Player1Tie === 'string') this.Set2Player1Tie = parseInt(init.Set2Player1Tie, 10);
      if (typeof init.Set2Player2Tie === 'string') this.Set2Player2Tie = parseInt(init.Set2Player2Tie, 10);
      if (typeof init.Set3Player1Tie === 'string') this.Set3Player1Tie = parseInt(init.Set3Player1Tie, 10);
      if (typeof init.Set3Player2Tie === 'string') this.Set3Player2Tie = parseInt(init.Set3Player2Tie, 10);
   }
}